import React, { Component } from 'react';
import '../App.css';
import RenderPixels from './RenderPixels';
import {FaPlay} from 'react-icons/fa';
import {FaTimes} from 'react-icons/fa';
import {MdDonutLarge} from 'react-icons/md';

const emptyCell=<div className="EmptyCell"><FaPlay/></div>;
const OCell=<div className="Player1"><MdDonutLarge/></div>;
const XCell=<div className="Player2"><FaTimes/></div>;
const upperX=9;

class Engine extends Component {
  constructor(props){
    super(props);
    let pixels=new Array(upperX);
    this.state={
      pixels: pixels,
      player: 1,
      xWins: 0,
      oWins: 0
    }
    //this.initiatePopulation=this.initiatePopulation.bind(this);
    //this.manageClick=this.manageClick.bind(this);
  }

  initiatePopulation=()=>{
    let pixels=new Array(upperX);
      for(let i=0; i<upperX; i++){
          pixels[i]=emptyCell;
      }
      this.setState(prevState=>({
        pixels: pixels,
        player: 1
      }))
  }

  resetScores=()=>{
    this.setState(prevState=>({
      oWins: 0,
      xWins: 0
    }))
    this.initiatePopulation();
  }

  componentDidMount(){
    console.log("Engine Mounted");
    this.initiatePopulation();
  }

  manageClick=(id)=>{
      //console.log(id);
      let pixels=this.state.pixels;
      if(pixels[id]!==emptyCell)
        return;
      let nextPlayer=1;
      if(this.state.player===1){
          pixels[id]=OCell;
          nextPlayer=2;
      }
      else {
        pixels[id]=XCell;
        nextPlayer=1;
      }
      let flag = this.validateBoard();
      if(flag)
        this.setState(prevState=>({
          pixels: pixels,
          player: nextPlayer
        }))
      else {
        this.initiatePopulation();
      }
  }

  validateBoard=()=>{
      let pixels=this.state.pixels;
      let flag1=(pixels[0]===pixels[1] && pixels[1]===pixels[2] && (pixels[0]!==emptyCell && pixels[1]!==emptyCell && pixels[2]!==emptyCell));
      let flag2=(pixels[3]===pixels[4] && pixels[4]===pixels[5] && (pixels[3]!==emptyCell && pixels[4]!==emptyCell && pixels[5]!==emptyCell));
      let flag3=(pixels[6]===pixels[7] && pixels[7]===pixels[8] && (pixels[6]!==emptyCell && pixels[7]!==emptyCell && pixels[8]!==emptyCell));
      let flag4=(pixels[0]===pixels[3] && pixels[3]===pixels[6] && (pixels[0]!==emptyCell && pixels[3]!==emptyCell && pixels[6]!==emptyCell));
      let flag5=(pixels[1]===pixels[4] && pixels[4]===pixels[7] && (pixels[1]!==emptyCell && pixels[4]!==emptyCell && pixels[7]!==emptyCell));
      let flag6=(pixels[2]===pixels[5] && pixels[5]===pixels[8] && (pixels[2]!==emptyCell && pixels[5]!==emptyCell && pixels[8]!==emptyCell));
      let flag7=(pixels[0]===pixels[4] && pixels[4]===pixels[8] && (pixels[0]!==emptyCell && pixels[4]!==emptyCell && pixels[8]!==emptyCell));
      let flag8=(pixels[2]===pixels[4] && pixels[4]===pixels[6] && (pixels[2]!==emptyCell && pixels[4]!==emptyCell && pixels[6]!==emptyCell));
      if(flag1 || flag2 || flag3 || flag4 || flag5 || flag6 || flag7 || flag8){
        //console.log(this.state.player);
        if(this.state.player===1){
          this.setState((prevState)=>({
            oWins: prevState.oWins+1,
          }))
        }
        else{
          this.setState((prevState)=>({
            xWins: prevState.xWins+1,
          }))
        }
        return false;
      }

      return true;
  }

  render() {
    return (
      <div className="App">
        <div>
          <button className="selectButton"onClick={this.resetScores}>Reset scores</button>&nbsp;
            <button className="selectButton"onClick={this.initiatePopulation}>Reset board</button>
        </div>
        <div className="Pixels">
            <RenderPixels manageClick={this.manageClick}pixels={this.state.pixels} />
        </div>
        <br/>
        <div className="Wins">
          <div className="WinCell">
            {XCell}
            {this.state.xWins}
          </div>
          <div className="WinCell">
            {OCell}
            {this.state.oWins}
          </div>
        </div>

      </div>
    );
  }
}

export default Engine;



// WEBPACK FOOTER //
// ./src/Components/Engine.js